import React from 'react';
import classNames from 'classnames';

import '../styles/two-column.css';

function Left({ children }: React.PropsWithChildren) {
  return (
    <div className="two-column-left">
      {children}
    </div>
  );
}

function Right({ children }: React.PropsWithChildren) {
  return (
    <div className="two-column-right">
      {children}
    </div>
  );
}

interface TwoColumnProps extends React.PropsWithChildren {
  right?: boolean;
}

export default function TwoColumn({ children, right = false }: TwoColumnProps) {
  return (
    <div className={classNames('two-column', { right })}>
      {children}
    </div>
  );
}

TwoColumn.Left = Left;
TwoColumn.Right = Right;
